import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { normalizeHttpError, } from '@spartacus/core'
import { catchError, map, mergeMap } from 'rxjs/operators'
import { MbUserAddressConnector } from '../../connectors'
import { MbUserAddressesAction } from '../actions'

@Injectable({
  providedIn: 'root'
})
export class MbUserAddressesEffects {

  loadAllUserAddresses$ = createEffect(() => this.actions$.pipe(
    ofType(MbUserAddressesAction.LOAD_ALL_USER_ADDRESSES),
    map((action: MbUserAddressesAction.LoadAllUserAddresses) => action.payload),
    mergeMap(payload => this.mbUserAddressConnector.getAll(payload).pipe(
      map(addresses => new MbUserAddressesAction.LoadAllUserAddressesSuccess(addresses)),
      catchError(error => of(new MbUserAddressesAction.LoadAllUserAddressesFail(normalizeHttpError(error))))
    ))
  ))

  constructor (protected actions$: Actions,
              protected mbUserAddressConnector: MbUserAddressConnector) {
  }
}
